export default __webpack_public_path__ + "static/media/1536.34fe7853.png";